import { t } from "i18next";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import moment from 'moment';
import { Button, Form } from "react-bootstrap";
import { AdminClubNew } from "./club-new";
import { AdminClubDelete } from "./club-delete";
import { AdminClubEdit } from "./club-edit";
import { Club } from "../../../../interfaces/club";
import { getClubOptions, getClubs } from "../../../../services/club";
import { getPaginationOptions, tableStyles } from "../../../../util/data-table";

export function AdminClubList() {
    const [clubs, setClubs] = useState<Club[]>([]);
    const [showAddNew, setShowAddNew] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [selectedId, setSelectedId] = useState(0);
    
    const CustomDate = (row: any ) => (
        <span>
            { moment(row.row.changed_at).format("DD/MM/YYYY HH:mm") }
        </span>
    );
    
    const CustomActions = (row: any) => (
        <span>
            <a href="#" className="icon-link edit" title={ t("edit") } onClick={ handleEdit } data-id={ row.row.id }>
                <i className="bi bi-pencil-square"></i>
            </a>
            <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ row.row.id }>
                <i className="bi bi-trash"></i>
            </a>
        </span>
    );

    const CustomLogo = (row: any) => (
        <div className="image">
            { row.row.logo.length > 0 &&
                <img src={ row.row.logo[0].src } alt={ row.row.logo[0].name } />
            }
        </div>
    );

    const columns = [
        {
            id: 'id',
            name: '#',
            selector: (row: any) => row.id,
            sortable: true
        },
        {
            id: 'name',
            name: t("Name"),
            selector: (row: any) => row.name,
            sortable: true
        },
        {
            id: 'email',
            name: t('email'),
            selector: (row: any) => row.email,
            sortable: true
        },
        {
            id: 'phone',
            name: t('phone'),
            selector: (row: any) => row.phone,
            sortable: true
        },
        {
            id: 'logo',
            name: t('logo'),
            selector: (row: any) => row.logo,
            sortable: false,
            cell: (row: any) => <CustomLogo row={row} />
        },
        {
            id: 'changed_at',
            name: t('changed_at'),
            selector: (row: any) => row.changed_at,
            sortable: true,
            cell: (row: any) => <CustomDate row={row} />,
        },
        {
            id: 'actions',
            name: t("actions"),
            cell: (row: any) => <CustomActions row={row} />,
        }

    ];

    useEffect(() => {
        getClubs()
            .then(response => {
                setClubs(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();

        const s = event.target.search.value;

        getClubs(s)
            .then(response => {
                setClubs(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAddNew(true)
    }

    const handleAddNewOnSave = (c: Club) => {
        const newClubs = [
            c,
            ...clubs
        ];
        setClubs(newClubs);
        setShowAddNew(false);
    }

    const handleAddNewOnClose = () => {
        setShowAddNew(false);
    }

    const handleDelete = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowDelete(true);
    }

    const handleDeleteOnDelete = (id: number) => {
        setSelectedId(0);
        const newClubs = clubs.filter((m: Club) => m.id != id);
        setClubs(newClubs);
        setShowDelete(false);
    }

    const handleDeleteOnClose = () => {
        setSelectedId(0);
        setShowDelete(false);
    }

    const handleEdit = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowEdit(true);
    }

    const handleEditOnSave = (changedClub: Club) => {
        setSelectedId(0);
        const newClubs = clubs.map((m: Club) => {
            if (m.id == changedClub.id) {
                return changedClub;
            } else {
                return m;
            }
        });
        setClubs(newClubs);
        setShowEdit(false);
    }

    const handleEditOnClose = () => {
        setSelectedId(0);
        setShowEdit(false);
    }

    return (
        <div className="club-list-container">
            <h1>
                { t('clubs')}
            </h1>
            <div className="filters-container">
                <Form onSubmit={ handleSearchSubmit }>
                    <Form.Group className="field-search" controlId="search">
                        <Form.Control type="search" placeholder={ t("Write to search") } />
                    </Form.Group>
                    <div className="actions">
                        <Button variant="primary" type="submit">
                            { t("search") }
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="table-container">
                <DataTable
                    columns={ columns }
                    data={clubs}
                    // selectableRows={ true }
                    // selectableRowsHighlight={ true }
                    responsive={ true }
                    striped={ true }
                    highlightOnHover={ true }
                    defaultSortFieldId={ 'changed_at' }
                    defaultSortAsc={ false }
                    pagination={ true }
                    customStyles={ tableStyles }
                    paginationComponentOptions={ getPaginationOptions() }
                />
            </div>            
            <a className="admin-add-new" href="#" onClick={ handleAddNew }>
                <i className="bi bi-plus-circle"></i>
            </a>
            { showAddNew &&
                <AdminClubNew onSave={ handleAddNewOnSave } onClose={ handleAddNewOnClose } />
            }
            { showDelete && (selectedId != 0) &&
                <AdminClubDelete id={ selectedId } onDelete={ handleDeleteOnDelete } onClose={ handleDeleteOnClose } />
            }
            { showEdit && (selectedId != 0) &&
                <AdminClubEdit id={ selectedId } onSave={ handleEditOnSave } onClose={ handleEditOnClose } />
            }
        </div>

    )
}